import React, { useState } from 'react'

import { url } from '../../constants' 
import { Metacritic } from '../'
import { Platforms } from '../'
import { getPrettyDate } from '../../utils'

import './Game.css'
import { Navigate } from 'react-router-dom'

const Game = ({data:{ id, name, background_image, rating, released, metacritic,genres,parent_platforms,playtime }}) => {
  const game_image_url = background_image ? background_image.split(url.BASE_IMAGE_URL)[1] : null
  const cropped_image_url = game_image_url ? url.CROP_IMAGE_URL+ game_image_url : null
  let genre_list =  genres.map(genre =>(genre.name))
  const [gameClicked, setGameClicked] = useState(false);

  function redirectToGamePage() {
    setGameClicked(true)
  }
  return (
    <div className='gameTile' >
      {gameClicked && <Navigate to={`/game/${id}`}/>}
      {cropped_image_url ? <img src={cropped_image_url} alt={name} /> : <></>}
      <div className='gametile__info'>
        <div className='info-header'>
          <Platforms parent_platforms={parent_platforms} />
          <Metacritic metacritic={ metacritic }/>
        </div>
        <div className='info-title' onClick={redirectToGamePage}><h3>{name} &rarr;</h3></div>
        <div className='info-more'>
          <ul>
            <li>
              <div>
                <span className='more-list-title'>Average User Rating</span>
                <span>{rating}</span>
              </div>
            </li>
            <li>
              <div>
                <span className='more-list-title'>Release Date</span>
                <span>{getPrettyDate(released)}</span>
              </div>
            </li>
            <li>
              <div>
                <span className='more-list-title'>Genres</span>
                <span>{genre_list.join(', ')}</span>
              </div>
            </li>
            <li>
              <div>
                <span className='more-list-title'>Playtime</span>
                <span>{playtime} hours</span>
              </div>
            </li>
          </ul>
        </div>
        
      </div>
    </div>
  )
}

export default Game